// Client-side cache for market movers (gainers, losers, most active).
// TTL is synchronized from server response when available.

const DEFAULT_MOVERS_CACHE_TTL_MS = 2 * 60 * 1000; // 2 minutes
let moversCache = { data: null, timestamp: 0, ttlMs: DEFAULT_MOVERS_CACHE_TTL_MS };

const resolveTtlMs = (providedTtlMs, data) => {
  if (Number.isFinite(providedTtlMs) && providedTtlMs > 0) {
    return providedTtlMs;
  }
  if (Number.isFinite(data?.cacheTtlMs) && data.cacheTtlMs > 0) {
    return data.cacheTtlMs;
  }
  return DEFAULT_MOVERS_CACHE_TTL_MS;
};

export const getMoversCacheTtlMs = () => moversCache.ttlMs || DEFAULT_MOVERS_CACHE_TTL_MS;

/**
 * Get cached movers if still valid.
 * @returns {{ gainers: Array, losers: Array, mostActive: Array, cachedAt: number } | null}
 */
export const getCachedMovers = () => {
  if (!moversCache.data) return null;
  const ttlMs = moversCache.ttlMs || DEFAULT_MOVERS_CACHE_TTL_MS;
  const age = Date.now() - moversCache.timestamp;
  if (age >= ttlMs) {
    moversCache = { data: null, timestamp: 0, ttlMs };
    return null;
  }
  return { ...moversCache.data, cachedAt: moversCache.timestamp, cacheTtlMs: ttlMs };
};

export const clearMoversClientCache = () => {
  moversCache = { data: null, timestamp: 0, ttlMs: DEFAULT_MOVERS_CACHE_TTL_MS };
};

/**
 * Store movers in cache.
 * @param {{ gainers: Array, losers: Array, mostActive: Array, cachedAt?: number, cacheTtlMs?: number }} data
 * @param {number} [ttlMs]
 */
export const setCachedMovers = (data, ttlMs) => {
  if (data && Array.isArray(data.gainers) && Array.isArray(data.losers) && Array.isArray(data.mostActive)) {
    const effectiveTtlMs = resolveTtlMs(ttlMs, data);
    const timestamp = Number.isFinite(data.cachedAt) && data.cachedAt > 0 ? data.cachedAt : Date.now();
    moversCache = { data: { ...data }, timestamp, ttlMs: effectiveTtlMs };
  }
};
